var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReschedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.11 8C14.11 9.18669 13.7581 10.3467 13.0988 11.3334C12.4395 12.3201 11.5024 13.0892 10.4061 13.5433C9.30973 13.9974 8.10333 14.1162 6.93945 13.8847C5.77556 13.6532 4.70646 13.0818 3.86735 12.2426C3.02823 11.4035 2.45679 10.3344 2.22528 9.17054C1.99377 8.00666 2.11259 6.80026 2.56671 5.7039C3.02084 4.60754 3.78987 3.67047 4.77657 3.01118C5.76326 2.35189 6.9233 2 8.10999 2C9.78999 2 11.3967 2.66667 12.6033 3.82667L14.11 5.33333",
    stroke: "#7E22CE",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1099 2V5.33333H10.7766",
    stroke: "#7E22CE",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReschedule);
export default __webpack_public_path__ + "static/media/reschedule.ed1dcb1ee97e653d8841d4d475a6662b.svg";
export { ForwardRef as ReactComponent };